import { useNavigate } from 'react-router-dom'
import ROUTES from '@client-hub/shared/constants/routes'
import MfaEnable, { MfaEnableContentType } from 'components/Mfa/Enable'
import { useMfaNavigateState, useRedirect } from 'hooks'

const MfaSetup = () => {
  const content: MfaEnableContentType = { showLogo: true }
  const navigate = useNavigate()
  const { isAllowedMfa, uid } = useMfaNavigateState()

  useRedirect(!isAllowedMfa)

  const onSuccess = (state: Record<string, unknown>) => navigate(ROUTES.MFA.SETUP.CODE, { state })

  if (!isAllowedMfa) return null

  return <MfaEnable content={content} onSuccess={onSuccess} uid={uid} />
}

export default MfaSetup
